import { h } from 'preact'; /** @jsx h */

import './StickyCTA.scss';

const StickyCTA = ({
    title = 'Bli støttemedlem',
    text = 'Støtt Stiftelsen Norsk Luftambulanse med et engangsbeløp eller bli fast støttemedlem. Du kan også gi en gave i gave.',
    buttonText = 'Støtt oss her',
    link = '/gave/',
    orientation = 'right',
    buttonCaption = '',
    icon = false,
    target = '_self',
    spaceY = false
}) => {
    return (
        <div className={`cta-wrapper cta-wrapper-${orientation}`}>
            <div className={`sticky-cta ${spaceY ? 'space-y' : ''}`}>
                <a
                    className={`sticky-cta-content ${buttonCaption === '' && 'no-btn-caption'}`}
                    href={link}
                    target={target}
                >
                    <h3 className="sticky-cta-title">{title}</h3>
                    <div className="sticky-cta-line top" />
                    <svg
                        className="sticky-cta-heart"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 29 25"
                    >
                        <path
                            d="M26.27,2.68a7.72,7.72,0,0,0-10.75,0l-1,1-1-1a7.73,7.73,0,0,0-10.75,0,7.33,7.33,0,0,0,0,10.53L14.15,24.36a.51.51,0,0,0,.7,0L26.27,13.21a7.33,7.33,0,0,0,0-10.53Z"
                            fill="#fff"
                        />
                    </svg>
                    <p className="sticky-cta-text">{text}</p>
                    <div className="sticky-cta-line bottom" />
                    <div className="sticky-cta-btn">
                        <a className={`cta-btn ${icon && 'with-icon'}`} href={link} target={target}>
                            <span>{buttonText}</span>
                            {icon && (
                                <span className="material-symbols-outlined">arrow_forward</span>
                            )}
                        </a>
                    </div>
                    {buttonCaption !== '' && (
                        <span className="sticky-cta-caption">{buttonCaption}</span>
                    )}
                </a>
            </div>
        </div>
    );
};

export default StickyCTA;
